import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    for (const url of [
      'maps.googleapis.com',
      'auth/saml/sso',
    ]) {
      if (request.url.indexOf(url) !== -1) {
        return next.handle(request);
      }
    }

    const authService = this.injector.get(AuthService);
    const token = authService.getSessionToken();
    const headers = {};

    if (token) {
      headers['Authorization'] = 'Bearer ' + authService.getSessionToken();
    }

    request = request.clone({
      setHeaders: headers
    });
    return next.handle(request);
  }
}
